<template>
<section>
  <!-- <b-breadcrumb
            align="is-left"
        >
            <b-breadcrumb-item tag='router-link' to="/">Home</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/documentation">Docs</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/documentation/breadcrumb" active>Breadcrumb</b-breadcrumb-item>
        </b-breadcrumb> -->
    <div class="my-breadcrumb is-size-7 is-size-7-mobile">
      <router-link to="/">Home</router-link>
      <span class='separator'>/</span>

      <router-link v-if="levelTwoLink" :to="levelTwoLink">{{levelTwoText}}</router-link>
      <span v-if="!levelTwoLink">{{levelTwoText}}</span>

      <span v-if="levelThreeText" class='separator'>/</span>

      <router-link v-if="levelThreeLink" :to="levelThreeLink">{{levelThreeText}}</router-link>
      <span v-if="levelThreeText && !levelThreeLink">{{levelThreeText}}</span>
      
      <span v-if="levelFourText" class='separator'>/</span>
      <span v-if="levelFourText">{{levelFourText}}</span>


    </div>
  </section>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ['levelTwoText', 'levelTwoLink', 'levelThreeText', 'levelThreeLink', 'levelFourText'],
  data () {
    return {
      link: "test"
    }
  },
  methods: {
   
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-breadcrumb {
    padding:20px 0 0 0;
  }
  .my-breadcrumb .separator {
    margin-left:8px;
    margin-right:8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue